export enum TestOpsPlatformTierType {
  FREE = 'FREE',
  PROFESSIONAL = 'PROFESSIONAL',
  BUSINESS = 'BUSINESS',
  ENTERPRISE = 'ENTERPRISE',
}
